<template>
    <div id="contact_centers">
        <h1>Контакты</h1>
        <div class="contact_centers--wrapper">
            <div class="contact_centers--cards">
                <contacts_card v-for="city in cities"
                               :key="city"
                               :city="city"
                               @id="getCenterID"
                               :centers="centers"
                />
            </div>
            <div class="contact_centers--map">
                <yandex_map :centers="centers" :card_coords="card_coords"/>
            </div>
        </div>
    </div>
</template>

<script>
    import Contacts_card from "./components/contacts_card";
    import Yandex_map from "./components/yandex_map";
    import {
        cityNames,
        pickupLocationCoords
    } from './components/contacts/pickup_locations';

    export default {
        name: "contact_centers",
        components: {Yandex_map, Contacts_card},
        data(){
            return {
                centers: [],
                cities: [],
                card_coords: [],
                address:[]
            }
        },

        methods: {
            loadCenters(){
                this.$http.get('/pickup_locations')
                .then(response => this.getCenters(response.body.data))
                .catch(() => this.getCenters([]));
            },

           getCenters(data){
                this.centers = Array.isArray(data) ? data : []
                this.cities = cityNames(this.centers)
            },
            getCenterID (data) {
              let pickupLocation = this.centers.find(i => data.id === i.attributes.id)
              let coords = pickupLocationCoords(pickupLocation)
              this.card_coords = coords || []
            }
        },
        created(){
            this.loadCenters()
        }
    }
</script>
<style scoped>
</style>
